const selector = '[data-js-customer-service-queue-time]';

const queueTime = function (el, app) {

    const $el = $(el);

    if ($el.length === 0) {
        return;
    }

    const $text = $el.children("span").eq(0)

    const init = function () {
        update()
    }

    const update = function () {

        // async/await doesn't work with current build setup
        // const r = await $.get("/site-api/customer-service/queue-time")

        $.get("/site-api/customer-service/queue-time")
            .then(r => {
                if (r.status === 'Ok') {
                    const text = r.result.text;
                    $text.text('');
                    if (text === null) {
                        $el.addClass('Ge-Hidden');
                        $el.nextUntil( ":not(br)" ).addClass("Ge-Hidden");
                    }
                    else {
                        $text.text(text);
                        $el.removeClass('Ge-Hidden');
                        $el.nextUntil( ":not(br)" ).remove("Ge-Hidden");
                    }
                    setTimeout(update, 60000);
                }
                else {
                    setTimeout(update, 300000);
                }
            });
    };

    return {
        init: init()
    };

};

queueTime.selector = selector;

export default queueTime;
